<template>
  <div class="language-selector">
    <GeneralElementsSelect
      :items="availableLocales"
      :selected-item="selectedLocale"
      @select="setLanguage"
    >
      <template #icon>
        <img
          src="~/assets/icons/globe.svg"
          width="20"
          height="20"
          alt="Globe icon"
        />
      </template>
    </GeneralElementsSelect>
  </div>
</template>

<script lang="ts" setup>
  import type { LocaleObject } from 'vue-i18n-routing'
  import type { SelectItem } from '~/types/General/Elements/SelectItem'
  import { useAppStore } from '~/stores'

  const appStore = useAppStore()
  const { push: routerPush } = useRouter()
  const { locales, locale, setLocale, finalizePendingLocaleChange } = useI18n()

  const availableLocales = computed(() => {
    return (locales.value as LocaleObject[]).filter((i) => i.code !== locale.value) as SelectItem[]
  })

  const selectedLocale = computed(() => {
    return (locales.value as LocaleObject[]).find((i) => i.code === locale.value) as SelectItem
  })

  function setLanguage(value: any) {
    GTM.languageSwitch(locale.value, value.code)

    setLocale(value.code)

    finalizePendingLocaleChange().then(() => {
      const path = appStore.slugs[value.code] ?? `/${locale.value}`

      routerPush(path)
    })
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .language-selector {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    position: relative;

    img {
      height: 20px;
      width: 20px;
    }

    .dropdown {
      :deep(.selected:after) {
        display: none;
      }

      :deep(.selected span) {
        @include mobile {
          padding: 0;
          display: none;
        }

        span {
          @include mobile {
            display: none;
          }
        }
      }

      :deep(.options) {
        @include mobile {
          right: -4px;
        }
      }
    }
  }
</style>
